import { Injectable } from '@angular/core';
import { ResourceVm } from 'qp-ui-interface';
import { getSeriesName } from 'qp-utility';
import { LocalStorageKeys } from '../../../shared/LocalStorageKeys';
import { TabService } from '../../../shared/services/tabs/tab.service';
import { ChannelInfo, CollectionInfo, ContainerInfo, ContentInfo, TabInfo } from './../models/newrelic.model';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class NewrelicContentStore {
  private currentResource: ResourceVm;
  constructor(private tabService: TabService, private localStorage: LocalStorageService) {}

  public setContentDetails(resource: ResourceVm) {
    this.currentResource = resource;
  }

  public getContentDetails(): ResourceVm {
    return this.currentResource;
  }

  public getCollectionInfo(): CollectionInfo {
    return {
      collectionID: this.currentResource?.collectionID || 'NA',
      collectionName: this.currentResource?.collectionName || 'NA',
    };
  }

  public getTabInfo(): TabInfo {
    return {
      tabID: this.tabService?.currentTabId,
      tabName: this.tabName(),
    };
  }

  private tabName(): string {
    let tabName: string;
    if (this.tabService.currentTabName?.toLowerCase() !== 'search') {
      this.tabService.tabsInfo.filter((info) => {
        if (info?.name === this.tabService?.currentTabName) {
          if (info?.data !== undefined) {
            tabName = info?.data === 'all' ? 'home' : info?.data;
          } else {
            tabName = info?.name === 'all' ? 'home' : info?.name;
          }
        }
      });
    } else {
      tabName = this.tabService?.currentTabName;
    }
    return tabName;
  }

  public getChannelInfo(): ChannelInfo {
    return this.currentResource?.contentType === 'channel'
      ? {
          channelName: this.currentResource?.title,
          channelID: this.currentResource?.id,
        }
      : undefined;
  }

  public getContainerInfo(): ContainerInfo {
    const containerName =
      this.currentResource?.containerName?.toLowerCase() === 'highlights' ? 'Hero' : this.currentResource?.containerName || 'NA';
    return {
      containerID: this.currentResource?.containerId || 'NA',
      containerName: containerName || 'NA',
    };
  }

  public getContentInfo(): ContentInfo {
    return {
      storefrontID: this.localStorage.getItem(LocalStorageKeys.STOREFRONTID),
      providerID: this.currentResource?.providerName,
      contentKey: this.currentResource?.key,
      contentID: this.currentResource?.id,
      contentType: this.currentResource?.contentType,
      contentGenre: this.currentResource?.contentGenre?.toString(),
      contentName: this.currentResource?.title,
      seriesName: getSeriesName(this.currentResource),
      episodeNumber: this.currentResource?.episodeNumber ? this.currentResource.episodeNumber.toString() : 'NA',
      seasonNumber: this.currentResource?.seasonNumber ? this.currentResource.seasonNumber.toString() : 'NA',
    };
  }
}
